import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationExportsManualPage } from "~/pages/Settings/Organisations/organisation/exports/OrganisationExportsManualPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/exports/manual",
)({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.exports") }] }),
  component: OrganisationExportsManualPage,
});
